// User-facing Italian labels for the Malattia wizard fields that can block
// "Continua". Mirrors src/screens/SaluteProduct/SaluteFormFlow.stepErrors.js.
export const STEP_FIELD_LABELS = {
  // Step 1 — Dati Personali
  gender: 'Il contraente è',
  name: 'Nome',
  surname: 'Cognome',
  date_of_birth: 'Data di nascita',
  commune_of_birth_code: 'Comune di nascita',
  province_of_birth_code: 'Provincia di nascita',
  born_abroad: "Nato all'estero",
  country_of_birth_code: 'Stato estero di nascita',
  residence_commune_code: 'Comune di residenza',
  residence_province_code: 'Provincia di residenza',
  postal_code: 'CAP',
  address: 'Indirizzo',
  house_number: 'Numero civico',
  email: 'Email',
  phone: 'Telefono',
  policy_effective_date: 'Data di decorrenza polizza',

  // Step 2 — Questionario Anamnestico
  invalidita_permanente_inabilita_temporanea: 'Invalidità permanente o inabilità temporanea',
  infortuni_subiti: 'Infortuni subiti',
  rifiuto_o_condizioni_speciali_polizza: 'Rifiuto o condizioni speciali polizza',
  polizza_malattia_annullata: 'Polizza malattia annullata',
  familiare_deceduto_prima_55_malattia: 'Familiare deceduto prima dei 55 anni',
  familiari_primo_grado_casi_malattie_ereditarie: 'Malattie ereditarie in famiglia',
  imperfezioni_fisiche_o_disturbi_funizonali: 'Imperfezioni fisiche o disturbi funzionali',
  uso_sostanze_stupefacenti_o_abuso_alcolici: 'Uso di sostanze stupefacenti o alcolici',
  fuma_piu_20_sigarette_al_giorno: 'Fumo (più di 20 sigarette al giorno)',
  malattie_ricovero_ospedaliero: 'Malattie con ricovero ospedaliero',
  disturbi_ricorrenti_malattia: 'Disturbi ricorrenti o malattia',
  infortuni_ricovero_postumi_invalidanti: 'Infortuni con postumi invalidanti',
  farmaci_terapeutici_continuativi: 'Farmaci terapeutici continuativi',
  terapie_emotrasfusioni_chemioterapia_radioterapia: 'Emotrasfusioni, chemioterapia o radioterapia',
  malattie_infezioni_controlli_periodici: 'Malattie o infezioni con controlli periodici',
  pressione_arteriosa_inferiore_140_90: 'Pressione arteriosa',
  colesterolo_totale: 'Colesterolo totale',
  diabete_mellito: 'Diabete mellito',
  altre_assicurazioni_stessi_rischi: 'Altre assicurazioni per gli stessi rischi',
};

export const getBlockingFields = (errors, stepFields) => (stepFields || []).filter((field) => errors && errors[field]);

// Keep the list short enough to stay readable inside a toast.
export const buildMissingFieldsMessage = (fields, labels = STEP_FIELD_LABELS, max = 3) => {
  const names = (fields || []).map((field) => labels[field] || field);
  if (names.length > max) {
    return `Compila i campi obbligatori: ${names.slice(0, max).join(', ')} e altri ${names.length - max}.`;
  }
  return `Compila i campi obbligatori: ${names.join(', ')}.`;
};
